import configureAxios from 'configure/axios';

const axios = configureAxios();

export const getAll = (userId) => axios.get(`purchases/`, { params: { user_profile: userId } });
export const fetchFiltered = (userId, params) => axios.get(`purchases/`, {
  params: {
    ...params,
    user_profile: userId
  }
});

export const create = (userId) => axios.post(`purchases/`, { user_profile: userId, });
export const loadLineItems = (purchaseId, page) => axios.get(`/purchases/${purchaseId}/lineitems/?page=${page}`);
export const addLineItem = (purchaseId, attrs) => axios.post(`purchases/${purchaseId}/add_item/`, attrs);
export const setShippingOptions = (purchaseId, attrs) => axios.post(`purchases/${purchaseId}/shipping_options/`, attrs);
export const recalculateShipping = (purchaseId) => axios.post(`purchases/${purchaseId}/recalculate_shipping/`);
export const find = (id) => axios.get(`purchases/${id}/`);
export const getHistory = (userId, page = 1) => axios.get(`purchases/?page=${page}&status=overdue,complete&user_profile=${userId}`);

export const createRenewal = (userId) => axios.post('purchases/renewal/', { user_profile: userId, use_credit: true });
export const destroy = (id) => axios.delete(`purchases/${id}/`);

export const allocate_sprint = (plan, subscription) => axios.post('cycles/upcoming/', { plan, subscription });
export const allocate_bypassed = (plan, subscription) => axios.post('bypassed/cycles/upcoming/', { plan, subscription });

export const createSprintUpgrade = (subscription_id, plan_id) => axios.post('purchases/plan/', {
  subscription_id,
  plan_id,
  is_upgrade: true,
  use_credit: true,
});

export const createBypassedUpgrade = (bypassed_subscription_id, bypassed_plan_id) => axios.post('purchases/bypassed_plan/', {
  bypassed_subscription_id,
  bypassed_plan_id,
  is_upgrade: true,
  use_credit: true,
});

export const createQuickUpgrade = (quick_subscription_id, quick_plan_id) => axios.post('purchases/quick_plan/', {
  quick_subscription_id,
  quick_plan_id,
  is_upgrade: true,
  use_credit: true,
});

export const mergePurchases = (purchaseId, attrs) => axios.post(`purchases/${purchaseId}/merge/`, attrs);

export const fetchMergePurchasePrice = (attrs) => axios.post(`purchases/totals/`, attrs);
